// Import and register stimulus controllers
import componentControllers from './**/*_controller.js'
componentControllers.forEach((controller) => {
  Stimulus.register(controller.name, controller.module.default)
})

// Imports components/*_component.js files as-is
import './**/*_component.js'
